export default __webpack_public_path__ + "static/Arabian_Estates_Badge-06055418b96d0a68879bfdc56cc14607.svg";